import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { filter, firstValueFrom } from 'rxjs';

import { AuthService } from 'src/app/core/services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
	constructor(private _router: Router, private authService: AuthService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const redirectUrl = state.url === '/auth/logout' ? '/' : state.url;
		return this._check(redirectUrl);
	}

	/**
	 * Can activate child
	 *
	 * @param childRoute
	 * @param state
	 */
	canActivateChild(
		childRoute: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	) {
		const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
		return this._check(redirectUrl);
	}

	/**
	 * Check the authenticated status
	 *
	 * @param redirectURL
	 * @private
	 */
	private async _check(redirectTo: string): Promise<boolean> {
		try {
			if (this.authService.cognitoUserState.getValue() === 'loading') {
				await firstValueFrom(
					this.authService.cognitoUserState$.pipe(
						filter(state => state === 'ready')
					)
				);
			}
			await Auth.currentAuthenticatedUser();
			return true;
		} catch {
			await this.authService.logout(redirectTo);
			return false;
		}
	}
}